import React from "react";
import PredictionPage from "../../components/PredictionPage";

function Soybean() {
  return (
    <PredictionPage
      title="Soybean"
      content="This is the Soybean AI Trading Predictions page."
      canonical="/commodities/soybean-ai-trading-predictions"
      categoryKey="nav.commodities"
      categoryPath="/commodities"
      symbol="SOYBEAN"
    />
  );
}

export default Soybean;
